import { create } from 'zustand';

export type WallAiJobStatus = 'queued' | 'processing' | 'applying' | 'completed' | 'failed';

export interface WallAiJob {
  id: string;
  requestedBy: string;
  status: WallAiJobStatus;
  error: string | null;
}

interface WallAiJobStore {
  themeGroupingJob: WallAiJob | null;
  setThemeGroupingJob: (job: WallAiJob | null) => void;
}

export const useWallAiJobStore = create<WallAiJobStore>((set) => ({
  themeGroupingJob: null,
  setThemeGroupingJob: (themeGroupingJob) => set({ themeGroupingJob }),
}));
